import { GET_CURRENTLY_PLAYING_AUDIO_UI_STATE } from './getCurrentlyPlayingAudioUiState';
import { GET_ACTIVE_LOG_POLLS } from './getActiveLogPolls';
import { GET_STATEMENTS_UI_STATE } from './getStatementsUiState';
import { GET_UI_STATE } from './getUiState';
import { GET_UNVIEWED_STATEMENTS } from './getUnviewedStatements';
import { GET_VIEW_UNMATCHED_TRACKS_ONLY } from './getViewUnmatchedTracksOnly';

export const uiStateQueryStrings = {
    GET_CURRENTLY_PLAYING_AUDIO_UI_STATE,
    GET_ACTIVE_LOG_POLLS,
    GET_STATEMENTS_UI_STATE,
    GET_UI_STATE,
    GET_UNVIEWED_STATEMENTS,
    GET_VIEW_UNMATCHED_TRACKS_ONLY,
};
